export var colors = [
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
  "#19A39C",
  "#F22574",
  "#B7C600",
  "#01C2E5",
  "#FFA700",
  "#CE51BF",
  "#2BA805",
  "#8819A3",
  "#EAD325",
  "#22E21A",
];

export var colorMap = {
  "label_dashboard_region_latinAmericaCaribbean": "#19A39C",
  "label_dashboard_region_europeCentralAsia": "#F22574",
  'label_dashboard_region_southAsia': "#B7C600",
  "label_dashboard_region_subsaharanAfrica": "#01C2E5",
  "label_dashboard_region_MiddleEastNorthAfrica": "#FFA700",
};
